import React from 'react';
import { makeStyles, Typography, TypographyProps } from '@material-ui/core';

export type DataGridTitleProps = {
  title?: string;
  titleProps?: TypographyProps;
};

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
  },
}));

export const DataGridTitle = ({ title, titleProps }: DataGridTitleProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Typography id="datagrid-title" data-testid="datagrid-title" className={classes.root} {...titleProps}>
      {title}
    </Typography>
  );
};

export default DataGridTitle;
